module.exports = __webpack_public_path__ + "static/media/001-balloon-red.af40fdef.svg";